import { Breadcrumb, Breadcrumbs } from '@components/breadcrumbs';
import { Group } from '@components/layout';
import { Stack } from '@mui/material';
import { useWorkspaceContext } from '@navigation/WorkspaceContext';
import { WorkspacesMoreDropdown } from '@subsets/workspaces';
import { PageHeader, PageHeaderProps } from './PageHeader';

type WorkspacePageHeaderProps = PageHeaderProps & {
  mainBreadcrumbs?: Breadcrumb[];
  subBreadcrumbs?: Breadcrumb[];
};

export const WorkspacePageHeader = ({
  mainBreadcrumbs = [],
  subBreadcrumbs = [],
  children,
}: WorkspacePageHeaderProps) => {
  const { workspace } = useWorkspaceContext();

  const breadcrumbsWithWorkspaceName = [
    {
      label: workspace?.name,
      href: `/${workspace?.organizationId}/workspaces/${workspace?.workspaceId}`,
      action: <WorkspacesMoreDropdown workspace={workspace} isLandingPageWorkspace={false} />,
    },
    ...mainBreadcrumbs,
  ];

  return (
    <PageHeader>
      <Stack>
        <Breadcrumbs breadcrumbs={breadcrumbsWithWorkspaceName} />
        {subBreadcrumbs.length > 0 && <Breadcrumbs breadcrumbs={subBreadcrumbs} variant="body2" />}
      </Stack>
      <Group>{children}</Group>
    </PageHeader>
  );
};
